// Thin wrapper around fetch that throws on non-2xx and always sends cookies.

async function req(method, path, body) {
  const res = await fetch(path, {
    method,
    credentials: 'same-origin',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let msg = res.statusText;
    try { const j = await res.json(); msg = j.error || msg; } catch (_) {}
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }
  if (res.status === 204) return null;
  const ct = res.headers.get('content-type') || '';
  return ct.includes('application/json') ? res.json() : res.text();
}

export const api = {
  me:                () => req('GET',    '/api/me'),
  presets:           () => req('GET',    '/api/presets'),

  listEndpoints:     () => req('GET',    '/api/endpoints'),
  createEndpoint:    (b) => req('POST',  '/api/endpoints', b),
  updateEndpoint:    (id, b) => req('PATCH',  `/api/endpoints/${id}`, b),
  deleteEndpoint:    (id) => req('DELETE', `/api/endpoints/${id}`),
  regenerateEndpoint:(id) => req('POST',  `/api/endpoints/${id}/regenerate`),
  reorderEndpoints:  (ids) => req('POST', '/api/endpoints/reorder', { ids }),
  shareEndpoint:     (id) => req('POST',  `/api/endpoints/${id}/share`),
  revokeShare:       (id) => req('DELETE',`/api/endpoints/${id}/share`),

  listEvents:        (id) => req('GET',  `/api/endpoints/${id}/events`),
  clearEvents:       (id) => req('DELETE',`/api/endpoints/${id}/events`),
  pinEvent:          (id, pinned) => req('PATCH', `/api/events/${id}`, { pinned }),
  deleteEvent:       (id) => req('DELETE', `/api/events/${id}`),

  downloadUrl:       (id, format, range, from, to) => {
    const params = new URLSearchParams({ range });
    if (range === 'custom') { params.set('from', from); params.set('to', to); }
    return `/api/endpoints/${id}/download.${format}?${params.toString()}`;
  },

  login:             (username, password) => req('POST', '/auth/login', { username, password }),
  logout:            () => req('POST', '/auth/logout'),
};

export function openEventStream(endpointId, onEvent) {
  const es = new EventSource(`/api/endpoints/${endpointId}/stream`, { withCredentials: true });
  es.addEventListener('webhook', (e) => {
    try { onEvent(JSON.parse(e.data)); } catch (_) {}
  });
  return () => es.close();
}
